import React, { useContext, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useDocumentService from '../../../app/services/hooks/useDocumentService';

interface Props {
    documentId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const DocumentSwitchChange = ({ documentId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = useState<boolean>(checkValue);
    const { activeDocument, fetchingActiveDocument } = useDocumentService();

    const active = (value: boolean) => {
        setChecked(value);

        activeDocument(documentId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={documentId} callback={active} />;
};

export default DocumentSwitchChange;
